import { ILine } from '../types.DrawIt';

export const firstYear = (data: ILine[]) => data[0].year;

export const lastYear = (data: ILine[]) => data[data.length - 1].year;

export const middleYear = (data: ILine[]) => (lastYear(data) - firstYear(data)) / 2 + firstYear(data);

export const firstValue = (data: ILine[]) => data[0].value;

export const lastValue = (data: ILine[]) => data[data.length - 1].value;

export const middleValue = (data: ILine[]) => (lastValue(data) - firstValue(data)) / 2 + firstValue(data);
